import { ShippingDocumentKind } from "generated-graphql/graphql";
import { parseOmnisearchTokens } from "utils/omnisearchUtils";

/**
 * The Type filter's offered values. The grid reads processed manifests, and a
 * processed manifest is either a manifest or a bill of lading.
 */
export function shippingPaperworkKindValues(): ShippingDocumentKind[] {
  return [ShippingDocumentKind.Manifest, ShippingDocumentKind.BillOfLading];
}

/**
 * `search` narrowed to one kind. Any `kind:` term already in it is replaced, so
 * applying one prompt after another switches kinds instead of combining them.
 */
export function withKindTerm(search: string, kind: ShippingDocumentKind): string {
  return [
    ...parseOmnisearchTokens(search).filter((token) => !token.startsWith("kind:")),
    `kind:${kind}`,
  ].join(" ");
}
